import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';

import './AnimatedHourglass.scss';

const { block, element } = bem('hourglass');

let instanceCount = 0;

const CHAMBER_TOP = 'M76 64H124C124 87 100 100 100 100C100 100 76 87 76 64Z';
const CHAMBER_BOTTOM = 'M124 136L76 136C76 113 100 100 100 100C100 100 124 113 124 136Z';

const AnimatedHourglass = ({ className, size, loop, autoPlay, reducedMotion }) => {
  const idRef = useRef(null);
  if (idRef.current === null) {
    instanceCount += 1;
    idRef.current = `hg-${instanceCount}`;
  }
  const id = idRef.current;

  return (
    <div
      className={block(
        { [size]: true, paused: !autoPlay, 'reduced-motion': reducedMotion, 'no-loop': !loop },
        className
      )}
      aria-hidden="true">
      <svg className={element('svg')} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" fill="none">
        <defs>
          <clipPath id={`${id}-ct`}>
            <path d={CHAMBER_TOP} />
          </clipPath>
          <clipPath id={`${id}-cb`}>
            <path d={CHAMBER_BOTTOM} />
          </clipPath>
        </defs>

        <g className={element('body')}>
          <rect className={element('bar-top')} x="71" y="52" width="58" height="12" fill="#58A6FF" />
          <rect className={element('bar-bottom')} x="71" y="136" width="58" height="12" fill="#58A6FF" />
          <path className={element('chamber-top')} d={CHAMBER_TOP} fill="#C0E0FF" />
          <path className={element('chamber-bottom')} d={CHAMBER_BOTTOM} fill="#C0E0FF" />
          <g clipPath={`url(#${id}-ct)`}>
            <path className={element('fill-top')} d={CHAMBER_TOP} fill="#0077FF" />
          </g>
          <g clipPath={`url(#${id}-cb)`}>
            <path className={element('fill-bottom')} d={CHAMBER_BOTTOM} fill="#0077FF" />
          </g>
        </g>
      </svg>
    </div>
  );
};

AnimatedHourglass.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  loop: PropTypes.bool,
  autoPlay: PropTypes.bool,
  reducedMotion: PropTypes.bool,
};

AnimatedHourglass.defaultProps = {
  className: undefined,
  size: 'md',
  loop: true,
  autoPlay: true,
  reducedMotion: false,
};

export default AnimatedHourglass;
